export default __webpack_public_path__ + "static/MaisonMono-Italic-c49b16e8049d07c24a82fe998f533b24.woff2";